module.exports = __webpack_public_path__ + "static/img/testimony (16).31793a06.jpg";